import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'LatinoTypeVersusBlack';
    src: url('https://cdn.volkswagen.es/repository/fonts/latinotype/latinotype_versus_black.otf');
  }
  @font-face {
    font-family: 'LatinoTypeVersusBold';
    src: url('https://cdn.volkswagen.es/repository/fonts/latinotype/latinotype_versus_bold.otf');
  }
`;
